import httpClient from "@utils/httpClient";

export const getAllPolicySettings = async () => {
  try {
    const response = await httpClient.get('/leave-policy/all');
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getAllPolicySettings error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const getHolidayConfig = async (fyYear) => {
  try {
    const url = fyYear ? `/leave-policy/holiday-config?fy_year=${fyYear}` : '/leave-policy/holiday-config';
    const response = await httpClient.get(url);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getHolidayConfig error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const updateHolidayConfig = async (data) => {
  try {
    const response = await httpClient.put('/leave-policy/holiday-config', data);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('updateHolidayConfig error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const getCarryForwardRules = async () => {
  try {
    const response = await httpClient.get('/leave-policy/carry-forward');
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getCarryForwardRules error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const updateCarryForwardRule = async (leaveTypeId, data) => {
  try {
    const response = await httpClient.put(`/leave-policy/carry-forward/${leaveTypeId}`, data);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('updateCarryForwardRule error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const processCarryForward = async (fromFyYear) => {
  try {
    const response = await httpClient.post('/leave-policy/carry-forward/process', { from_fy_year: fromFyYear });
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('processCarryForward error:', error);

    // Extract statusCode from axios error if available
    const statusCode = error.response?.status || error.statusCode;
    const errorMessage = error.response?.data?.message || error.message;

    return {
      success: false,
      data: null,
      error: {
        message: errorMessage,
        statusCode: statusCode
      }
    };
  }
};

export const getCarryForwardLog = async (userId, fyYear) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append('user_id', userId);
    if (fyYear) params.append('fy_year', fyYear);
    const url = `/leave-policy/carry-forward/log${params.toString() ? '?' + params.toString() : ''}`;
    const response = await httpClient.get(url);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getCarryForwardLog error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const getProRataSettings = async () => {
  try {
    const response = await httpClient.get('/leave-policy/pro-rata');
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getProRataSettings error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const updateProRataSettings = async (data) => {
  try {
    const response = await httpClient.put('/leave-policy/pro-rata', data);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('updateProRataSettings error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const getAvailableFinancialYears = async () => {
  try {
    const response = await httpClient.get('/leaves/financial-years');
    return { success: response.success, data: response.data, currentFY: response.currentFY, error: response.error };
  } catch (error) {
    console.error('getAvailableFinancialYears error:', error);
    return { success: false, data: [], currentFY: null, error: { message: error.message } };
  }
};

export const getYearlyQuotas = async (fyYear) => {
  try {
    const response = await httpClient.get(`/leave-policy/yearly-quotas?fy_year=${fyYear}`);
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('getYearlyQuotas error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const updateYearlyQuota = async (leaveTypeId, fyYear, totalLeaves) => {
  try {
    const response = await httpClient.put('/leave-policy/yearly-quotas', {
      leave_type_id: leaveTypeId,
      fy_year: fyYear,
      total_leaves: totalLeaves
    });
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('updateYearlyQuota error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const deleteYearlyQuota = async (leaveTypeId, fyYear) => {
  try {
    const response = await httpClient.delete('/leave-policy/yearly-quotas', {
      data: {
        leave_type_id: leaveTypeId,
        fy_year: fyYear
      }
    });
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('deleteYearlyQuota error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

export const initializeFinancialYear = async (fyYear) => {
  try {
    const response = await httpClient.post('/leave-policy/initialize-fy', { fy_year: fyYear });
    return { success: response.success, data: response.data, error: response.error };
  } catch (error) {
    console.error('initializeFinancialYear error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};
